/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AreaDto {
    areaCode: string | null
    plantShortName: string | null
    description: string | null
}

export enum BatteryStatus {
    Good = 'Good',
    Low = 'Low',
    Empty = 'Empty',
    NotAvailable = 'NotAvailable',
}

export interface BulkOnboardSensorsResponseDto {
    success?: boolean
    message?: string | null
    metadata?: BulkOnboardingMetadataDto
    sensors?: BulkOnboardingItemResponseDto[] | null
}

export interface BulkOnboardingItemResponseDto {
    /** @format int32 */
    rowNumber?: number
    success?: boolean
    message?: string | null
    vendorSerialNumber?: string | null
    devEui?: string | null
    /** @format uuid */
    sensorDbKey?: string | null
}

export interface BulkOnboardingMetadataDto {
    /** @format date-time */
    timestamp?: string
    plant?: string | null
    /** @format int32 */
    totalRequested?: number
    /** @format int32 */
    totalAccepted?: number
    /** @format int32 */
    totalFailed?: number
}

/** @format int32 */
export enum ConfigurationIntervalType {
    Value0 = 0,
    Value1 = 1,
}

export interface ConfigurationResponseModel {
    success?: boolean
    message?: string | null
}

export interface CreateEchoViewRequest {
    sensors?: EchoTagInput[] | null
    label?: string | null
}

export interface DbLoRaWanData {
    devEUI: string | null
    vendorSerialNumber: string | null
    appEUI?: string | null
    encryptedAppKey?: string | null
    initializationVector?: string | null
    sensorModel?: string | null
    /** @format uuid */
    sensorDbKey?: string | null
    sensorSerialNumber?: string | null
    deviceProfileName?: string | null
}

export interface DbTimeseriesData {
    /** @format uuid */
    timeseriesTableDbKey: string
    omniaID: string | null
    tag: string | null
    plant: string | null
    payloadVariable: string | null
    /** @format uuid */
    sensorMetadataDbKey: string
    /** @format uuid */
    sensorDbKey: string
    vendorSerialNumber?: string | null
    modifiedBy?: string | null
}

export interface DbTimeseriesDeleteDto {
    omniaIds?: string[] | null
    tags?: string[] | null
    vendorSerialNumber?: string[] | null
}

export interface Device {
    /** @format uuid */
    dbKey?: string
    sensorModel: string | null
    protocol: string | null
    title?: string | null
    description?: string | null
    url?: string | null
    productPageLink?: string | null
    selectable?: boolean
    vendor?: string | null
    /** @format int32 */
    eqHubID?: number | null
    portfolio?: boolean
    displayName?: string | null
    deviceMeasurementType?: string | null
    atex?: string | null
    ipRating?: string | null
    range?: string | null
    lifespan?: string | null
    configurationIntervalType?: ConfigurationIntervalType
    /** @format int32 */
    configurationMeasurementFport?: number | null
    /** @format int32 */
    offlineAfterHours?: number
}

export interface DeviceDto {
    key: string | null
    title: string | null
    description?: string | null
    url?: string | null
    productPageLink?: string | null
    selectable?: boolean
    vendor?: string | null
    portfolio?: boolean
    displayName?: string | null
    protocol?: string | null
    deviceMeasurementType?: string | null
    atex?: string | null
    ipRating?: string | null
    range?: string | null
    lifespan?: string | null
}

/** @format int32 */
export enum DownlinkType {
    Value0 = 0,
    Value1 = 1,
}

export interface EchoTagInput {
    plant?: string | null
    tag?: string | null
}

export interface EchoViewResult {
    viewUrl?: string | null
    echoViewId?: string | null
}

export interface EditSensorResponseDto {
    success?: boolean
    message?: string | null
    updatedSensor?: InstalledSensorsDataDto
}

export interface ExistingImageDto {
    url?: string | null
    description?: string | null
}

export interface FileDto {
    fileName?: string | null
    url?: string | null
}

export interface FileHolderDto {
    result?: FileResultEnum
    file?: FileDto
}

export enum FileResultEnum {
    Success = 'Success',
    DoNotExist = 'DoNotExist',
    NoAccess = 'NoAccess',
}

export interface InsertImageFormDto {
    /** @format binary */
    file?: File | null
    description?: string | null
}

export enum InstalledSensorStatus {
    Start = 'Start',
    Onboarded = 'Onboarded',
    Unsuccessful = 'Unsuccessful',
    Draft = 'Draft',
    Deleted = 'Deleted',
    Prepared = 'Prepared',
    Active = 'Active',
    Offline = 'Offline',
}

export interface InstalledSensorsData {
    /** @format uuid */
    sensorDbKey?: string
    tag?: string | null
    plant: string | null
    area?: string | null
    project?: string | null
    /** @format uuid */
    deviceDbKey: string
    device?: Device
    superiorTag?: string | null
    vendorSerialNumber?: string | null
    devEui?: string | null
    status?: InstalledSensorStatus
    statusMessage?: string | null
    /** @format date-time */
    installationDate?: string
    /** @format date-time */
    firstActive?: string | null
    description?: string | null
    coordinates?: string | null
    coordinatesNotAvailable?: boolean
    plantId?: string | null
    images?: string | null
    modifiedBy?: string | null
}

export interface InstalledSensorsDataDto {
    /** @format uuid */
    sensorDbKey?: string | null
    tag?: string | null
    plant: string | null
    area?: string | null
    project: string | null
    sensorModel: string | null
    sensorType?: string | null
    superiorTag?: string | null
    vendorSerialNumber?: string | null
    vendor?: string | null
    status?: InstalledSensorStatus
    statusMessage?: string | null
    /** @format date-time */
    installationDate?: string
    /** @format date-time */
    firstActive?: string | null
    description?: string | null
    coordinates?: string | null
    coordinatesNotAvailable?: boolean
    protocol?: string | null
    plantId?: string | null
    hasAccess?: boolean
    battery?: TimeseriesValueDto
    batteryStatus?: BatteryStatus
    batteryEstimated?: boolean
    rssi?: TimeseriesValueDto
    snr?: TimeseriesValueDto
    sf?: TimeseriesValueDto
    signalQuality?: SignalQuality
    /** @format date-time */
    lastReceived?: string | null
}

export interface InstalledSensorsWithMetaData {
    installedSensor?: InstalledSensorsData
    attributedMetadata?: SensorMetaData
}

export interface MetadataDto {
    /** @format date-time */
    timestamp?: string
    plant?: string | null
    /** @format int32 */
    totalSensorsOnboarded?: number
    sensor?: OnboardingResponseDto
}

export interface OmniaTimeSeriesDto {
    /** @format uuid */
    timeseriesTableDbKey?: string
    name?: string | null
    description?: string | null
    standardUnit?: string | null
    unit?: string | null
    /** @format double */
    rangeHigh?: number
    /** @format double */
    rangeLow?: number
    /** @format double */
    latestValue?: number | null
    /** @format date-time */
    latestTime?: string | null
}

export interface OnboardSensorsResponseDto {
    success?: boolean
    message?: string | null
    metadata?: MetadataDto
}

export interface OnboardingRequest {
    plant: string | null
    project: string | null
    sensorModel: string | null
    plantId?: string | null
    sensor: OnboardingRequestSensor
}

export interface OnboardingRequestDto {
    plant: string | null
    project: string | null
    sensorModel: string | null
    plantId?: string | null
    sensor: OnboardingRequestSensorDto
}

export interface OnboardingRequestSensor {
    /** @format uuid */
    sensorDbKey?: string | null
    superiorTag?: string | null
    area?: string | null
    coordinates?: string | null
    tag?: string | null
    vendorSerialNumber?: string | null
    devEui?: string | null
    userAddedDescription?: string | null
    completeDescription?: string | null
    coordinatesNotAvailable?: boolean
    images?: string | null
}

export interface OnboardingRequestSensorDto {
    /** @format uuid */
    sensorDbKey?: string | null
    superiorTag?: string | null
    area?: string | null
    coordinates?: string | null
    tag?: string | null
    vendorSerialNumber?: string | null
    devEui?: string | null
    userAddedDescription?: string | null
    completeDescription?: string | null
    coordinatesNotAvailable?: boolean
    images?: InsertImageFormDto[] | null
    existingImageUrls?: ExistingImageDto[] | null
}

export interface OnboardingResponseDto {
    success?: boolean
    message?: string | null
    /** @format uuid */
    sensorDbKey?: string | null
}

export interface PlantDto {
    shortName: string | null
    description: string | null
    sapPlantId: string | null
    plantId?: string | null
}

export interface ProblemDetails {
    type?: string | null
    title?: string | null
    /** @format int32 */
    status?: number | null
    detail?: string | null
    instance?: string | null
    [key: string]: any
}

export interface ProjectDto {
    projectCode: string | null
    plantShortName: string | null
    description: string | null
}

export interface SensorDownlinkCapabilityDto {
    supportedTypes?: string[] | null
}

export interface SensorMetaData {
    /** @format uuid */
    sensorMetadataDbKey?: string | null
    /** @format uuid */
    deviceDbKey: string
    device?: Device
    payloadVariable: string | null
    unit?: string | null
    description: string | null
    /** @format double */
    rangeLow: number
    /** @format double */
    rangeHigh: number
    measurement: string | null
    attachedTransducer?: string | null
    sensorType?: SensorMetadataStatus
    deviceProfileName?: string | null
}

export interface SensorMetadataConfigurationDto {
    /** @format uuid */
    sensorMetadataConfigurationDbKey?: string
    /** @format int32 */
    seconds?: number
}

export interface SensorMetadataConfigurationResponseDto {
    confirmed?: SensorMetadataConfigurationDto
    pendingConfiguration?: SensorMetadataConfigurationDto
}

export interface SensorMetadataDeleteDto {
    sensorMetadataDbKeys?: (string | null)[]
}

export enum SensorMetadataStatus {
    None = 'None',
    Battery = 'Battery',
    Rssi = 'Rssi',
    Snr = 'Snr',
    Sf = 'Sf',
    BatteryVoltage = 'BatteryVoltage',
}

export enum SignalQuality {
    Good = 'Good',
    OK = 'OK',
    Bad = 'Bad',
    NotAvailable = 'NotAvailable',
}

export interface StidTagRequestModel {
    instCode: string | null
    tagNo: string | null
    superiorTag?: string | null
    superiorTagDescription?: string | null
    description?: string | null
    tagStatus?: string | null
    /** @format int32 */
    tagCategory?: number | null
    tagCategoryDescription?: string | null
    tagType?: string | null
    system?: string | null
    systemDescription?: string | null
    subSystem?: string | null
    mainSystem?: string | null
    projectCode?: string | null
    projectCodeDescription?: string | null
    locationCode?: string | null
    locationCodeDescription?: string | null
    disciplineCode?: string | null
    sequence?: string | null
    /** @format date-time */
    dateInstalled?: string | null
    remark?: string | null
    plantId?: string | null
    plantIdDescription?: string | null
    plantNo?: string | null
    /** @format int64 */
    xCoordinate?: number | null
    /** @format int64 */
    yCoordinate?: number | null
    /** @format int64 */
    zCoordinate?: number | null
    additionalFields?: any[] | null
    tagModXsToAdd?: TagModXsToAdd[] | null
    iiotTagNos?: string[] | null
    tagMountedOn?: string | null
    coordinates?: StidTagRequestModelCoordinate[] | null
}

export interface StidTagRequestModelCoordinate {
    /** @format int64 */
    xCoordinate?: number | null
    /** @format int64 */
    yCoordinate?: number | null
    /** @format int64 */
    zCoordinate?: number | null
}

export interface StidTagsResponseModel {
    instCode: string | null
    tagNo: string | null
    superiorTag?: string | null
}

export interface SuperiorTagDto {
    superiorTag: string | null
    plantShortName: string | null
}

export interface SyncTimeseriesRequest {
    plant?: string | null
    tag?: string | null
    /** @format uuid */
    sensorDbKey?: string | null
    deviceProfileName?: string | null
    updateExistingTimeseries?: boolean
}

export interface SyncTimeseriesResponseDto {
    createdTimeseries?: string[] | null
    updatedTimeseries?: string[] | null
    alreadyInSyncTimeseries?: string[] | null
    message?: string | null
}

export interface SystemDto {
    systemCode: string | null
    plantShortName: string | null
    description?: string | null
}

export interface TagDataDto {
    instCode: string | null
    tagNo: string | null
    plantId?: string | null
    plantIdDescription?: string | null
    projectCode?: string | null
    projectCodeDescription?: string | null
    system?: string | null
    systemDescription?: string | null
    locationCode?: string | null
    locationCodeDescription?: string | null
    /** @format date-time */
    dateInstalled?: string | null
    superiorTag?: string | null
    superiorTagDescription?: string | null
    description?: string | null
    tagStatus?: string | null
    files?: ThumbnailDto[] | null
    coordinates?: StidTagRequestModelCoordinate[] | null
}

export interface TagModXsToAdd {
    eqHubId?: string | null
    description?: string | null
    manufacturer?: string | null
    model?: string | null
    variant?: string | null
}

export interface ThumbnailDto {
    /** @format int32 */
    id?: number
    docNo?: string | null
    thumbnail?: string | null
    description?: string | null
    title?: string | null
    remark?: string | null
}

export interface TimeseriesDto {
    /** @format uuid */
    sensorDbKey?: string | null
    battery?: TimeseriesValueDto
    batteryStatus?: BatteryStatus
    batteryEstimated?: boolean
    rssi?: TimeseriesValueDto
    snr?: TimeseriesValueDto
    sf?: TimeseriesValueDto
    signalQuality?: SignalQuality
}

export interface TimeseriesLatestDto {
    /** @format uuid */
    timeSeriesTableDbKey?: string | null
    value?: TimeseriesValueDto
}

export interface TimeseriesMetadata {
    vendorSerialNumber?: string | null
    vendor?: string | null
    sensorModel?: string | null
    superiorTag?: string | null
    rangeLow?: string | null
    rangeHigh?: string | null
    attachedTransducer?: string | null
    /** @format uuid */
    sensorDbKey?: string | null
    sensorMetadataDbKey?: string | null
}

/** TimeseriesRequestItem */
export interface TimeseriesRequestItem {
    /** Gets or Sets Name */
    name?: string | null
    /** Gets or Sets Description */
    description?: string | null
    /** Gets or Sets Unit */
    unit?: string | null
    /** Gets or Sets Step */
    step?: boolean
    /** Gets or Sets ExternalId */
    externalId?: string | null
    /** Gets or Sets AssetId */
    assetId?: string | null
    /** Gets or Sets Facility */
    facility?: string | null
    /** Gets or Sets Source */
    source?: string | null
    /** Gets or Sets PlantSapCode */
    plantSapCode?: string | null
    /** Gets or Sets PlantStidCode */
    plantStidCode?: string | null
    metadata?: TimeseriesMetadata
}

export interface TimeseriesValueDto {
    /** @format double */
    value?: number
    /** @format date-time */
    time?: string
}

export interface TrendDto {
    unit?: string | null
    omniaId?: string | null
    /** @format double */
    rangeLow?: number
    /** @format double */
    rangeHigh?: number
    measurement?: string | null
    values?: TimeseriesValueDto[] | null
}

export interface UpdateSensorsDataDto {
    description?: string | null
    coordinates?: string | null
    plant?: string | null
    area?: string | null
    project?: string | null
    superiorTag?: string | null
    vendorSerialNumber?: string | null
    sensorModel?: string | null
    coordinatesNotAvailable?: boolean
    sensorIsPhysicallyMoved?: boolean
}

export interface UserSettingsDto {
    userId: string | null
    plant?: string | null
    consentTrendingApp?: boolean
    isNew?: boolean
}

export interface VendorSerialNumberCheckResultDto {
    alreadyInstalledSensors?: InstalledSensorsDataDto[] | null
    notReadyForOnboarding?: boolean
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean
    /** request path */
    path: string
    /** content type of request body */
    type?: ContentType
    /** query params */
    query?: QueryParamsType
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseType
    /** request body */
    body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
    securityWorker?: (
        securityData: SecurityDataType | null
    ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
    secure?: boolean
    format?: ResponseType
}

export enum ContentType {
    Json = 'application/json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
    public instance: AxiosInstance
    private securityData: SecurityDataType | null = null
    private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
    private secure?: boolean
    private format?: ResponseType

    constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
        this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || 'http://localhost:8080' })
        this.secure = secure
        this.format = format
        this.securityWorker = securityWorker
    }

    public setSecurityData = (data: SecurityDataType | null) => {
        this.securityData = data
    }

    protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
        const method = params1.method || (params2 && params2.method)

        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        }
    }

    protected stringifyFormItem(formItem: unknown) {
        if (typeof formItem === 'object' && formItem !== null) {
            return JSON.stringify(formItem)
        } else {
            return `${formItem}`
        }
    }

    protected createFormData(input: Record<string, unknown>): FormData {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key]
            const propertyContent: any[] = property instanceof Array ? property : [property]

            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
            }

            return formData
        }, new FormData())
    }

    public request = async <T = any, _E = any>({
        secure,
        path,
        type,
        query,
        format,
        body,
        ...params
    }: FullRequestParams): Promise<AxiosResponse<T>> => {
        const secureParams =
            ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
            {}
        const requestParams = this.mergeRequestParams(params, secureParams)
        const responseFormat = format || this.format || undefined

        if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
            body = this.createFormData(body as Record<string, unknown>)
        }

        if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
            body = JSON.stringify(body)
        }

        return this.instance.request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
            },
            params: query,
            paramsSerializer: { indexes: null },

            responseType: responseFormat,
            data: body,
            url: path,
        })
    }
}

/**
 * @title Api
 * @version 1.0
 * @baseUrl http://localhost:8080
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
    api = {
        /**
         * No description
         *
         * @tags DashboardTable
         * @name DashboardTableSensorListList
         * @summary Retrieves data used for sensor dashbord.
         * @request GET:/Api/DashboardTable/SensorList
         * @secure
         */
        dashboardTableSensorListList: (params: RequestParams = {}) =>
            this.request<InstalledSensorsWithMetaData[], any>({
                path: `/Api/DashboardTable/SensorList`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DbTimeseries
         * @name DbTimeseriesAllList
         * @summary Retrieves a list of all timeseries from timeseries Db.
         * @request GET:/Api/DbTimeseries/All
         * @secure
         */
        dbTimeseriesAllList: (params: RequestParams = {}) =>
            this.request<DbTimeseriesData[], any>({
                path: `/Api/DbTimeseries/All`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags DbTimeseries
         * @name DbTimeseriesVendorSerialNumberList
         * @summary Retrieves information about timeseries for the specified serial numbers.
         * @request GET:/Api/DbTimeseries/VendorSerialNumber
         * @secure
         */
        dbTimeseriesVendorSerialNumberList: (
            query?: {
                vendorSerialNumber?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<DbTimeseriesData[], any>({
                path: `/Api/DbTimeseries/VendorSerialNumber`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * @description Enter existing Tags to get table data
         *
         * @tags DbTimeseries
         * @name DbTimeseriesTagsList
         * @summary Retrieves information about timeseries for the specified tags.
         * @request GET:/Api/DbTimeseries/Tags
         * @secure
         */
        dbTimeseriesTagsList: (
            query?: {
                tags?: string[]
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/Api/DbTimeseries/Tags`,
                method: 'GET',
                query: query,
                secure: true,
                ...params,
            }),

        /**
         * @description Enter existing OmniaIDs to get table data
         *
         * @tags DbTimeseries
         * @name DbTimeseriesOmniaIdList
         * @summary Retrieves information about timeseries for the specified OmniaIDs.
         * @request GET:/Api/DbTimeseries/OmniaID
         * @secure
         */
        dbTimeseriesOmniaIdList: (
            query?: {
                omniaIds?: string[]
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/Api/DbTimeseries/OmniaID`,
                method: 'GET',
                query: query,
                secure: true,
                ...params,
            }),

        /**
         * @description , SensorMetadataID and SensorID must be a real and existing value from SensorMetadata table and InstalledSensors table respectively.
         *
         * @tags DbTimeseries
         * @name DbTimeseriesOnboardOneOrInBulkCreate
         * @summary Adds timeseries (one or in bulk) to DbTimeseries.
         * @request POST:/Api/DbTimeseries/Onboard one or in bulk
         * @secure
         */
        dbTimeseriesOnboardOneOrInBulkCreate: (data: DbTimeseriesData[], params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/Api/DbTimeseries/Onboard one or in bulk`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * @description Delete one or more lines of content from table, based on OmniaIDs, Tag or VendorSerialNumber
         *
         * @tags DbTimeseries
         * @name DbTimeseriesDeleteOneOrBulkOfSensorsWithOmniaIdTagOrVendorSerialNumberDelete
         * @summary Deletes one or more timeseries.
         * @request DELETE:/Api/DbTimeseries/Delete one or bulk of sensors with OmniaID, Tag or VendorSerialNumber
         * @secure
         */
        dbTimeseriesDeleteOneOrBulkOfSensorsWithOmniaIdTagOrVendorSerialNumberDelete: (
            data: DbTimeseriesDeleteDto,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/Api/DbTimeseries/Delete one or bulk of sensors with OmniaID, Tag or VendorSerialNumber`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Downlink
         * @name DownlinkPlantSensorFrequencyCreate
         * @request POST:/Api/Downlink/plant/{plant}/sensor/{sensorDbKey}/frequency
         * @secure
         */
        downlinkPlantSensorFrequencyCreate: (
            plant: string,
            sensorDbKey: string,
            query?: {
                /** @format int32 */
                seconds?: number
                type?: DownlinkType
            },
            params: RequestParams = {}
        ) =>
            this.request<ConfigurationResponseModel, any>({
                path: `/Api/Downlink/plant/${plant}/sensor/${sensorDbKey}/frequency`,
                method: 'POST',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Downlink
         * @name DownlinkSensorCapabilityDetail
         * @request GET:/Api/Downlink/sensor/{sensorDbKey}/capability
         * @secure
         */
        downlinkSensorCapabilityDetail: (sensorDbKey: string, params: RequestParams = {}) =>
            this.request<SensorDownlinkCapabilityDto, any>({
                path: `/Api/Downlink/sensor/${sensorDbKey}/capability`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags InstalledSensors
         * @name InstalledSensorsAllList
         * @summary Retrieves information about all installed sensors.
         * @request GET:/Api/InstalledSensors/All
         * @secure
         */
        installedSensorsAllList: (
            query?: {
                /** @format int32 */
                Page?: number
                /** @format int32 */
                PageSize?: number
                Search?: string
                Status?: InstalledSensorStatus[]
                Plant?: string
                Project?: string
                Area?: string
                Device?: string
                Protocol?: string
                SensorType?: string
                SuperiorTag?: string
                System?: string
                Tags?: string[]
                BatteryStatus?: BatteryStatus
                SignalQuality?: SignalQuality
                SortBy?: string
                SortDir?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<InstalledSensorsDataDto[], any>({
                path: `/Api/InstalledSensors/All`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags InstalledSensors
         * @name InstalledSensorsPlantSensorsDetail
         * @summary Retrieves information about the installed sensors of a plant.
         * @request GET:/Api/InstalledSensors/plant/{plant}/sensors
         * @secure
         */
        installedSensorsPlantSensorsDetail: (
            plant: string,
            query?: {
                /** @format int32 */
                Page?: number
                /** @format int32 */
                PageSize?: number
                Search?: string
                Status?: InstalledSensorStatus[]
                Plant?: string
                Project?: string
                Area?: string
                Device?: string
                Protocol?: string
                SensorType?: string
                SuperiorTag?: string
                System?: string
                Tags?: string[]
                BatteryStatus?: BatteryStatus
                SignalQuality?: SignalQuality
                SortBy?: string
                SortDir?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<InstalledSensorsDataDto[], any>({
                path: `/Api/InstalledSensors/plant/${plant}/sensors`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
 * No description
 *
 * @tags InstalledSensors
 * @name InstalledSensorsSensorsDetail
 * @summary Retrieves sensor information from specified serial number and sensor model,
optionally excluding the given sensor database key.
 * @request GET:/Api/InstalledSensors/sensors/{vendorSerialNumber}/{sensorModel}/{excludeSensorDbKey}
 * @secure
 */
        installedSensorsSensorsDetail: (
            vendorSerialNumber: string,
            sensorModel: string,
            excludeSensorDbKey: string,
            params: RequestParams = {}
        ) =>
            this.request<VendorSerialNumberCheckResultDto, any>({
                path: `/Api/InstalledSensors/sensors/${vendorSerialNumber}/${sensorModel}/${excludeSensorDbKey}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags InstalledSensors
         * @name InstalledSensorsDeviceDetail
         * @summary Retrieves the device a vendor serial number is pre-provisioned for, so onboarding can preselect the sensor model.
         * @request GET:/Api/InstalledSensors/device/{vendorSerialNumber}
         * @secure
         */
        installedSensorsDeviceDetail: (vendorSerialNumber: string, params: RequestParams = {}) =>
            this.request<DeviceDto, any>({
                path: `/Api/InstalledSensors/device/${vendorSerialNumber}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags InstalledSensors
         * @name InstalledSensorsVendorSerialNumberList
         * @summary Retrieves sensor information from specified serial number.
         * @request GET:/Api/InstalledSensors/VendorSerialNumber
         * @secure
         */
        installedSensorsVendorSerialNumberList: (
            query?: {
                vendorSerialNumber?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<InstalledSensorsDataDto[], any>({
                path: `/Api/InstalledSensors/VendorSerialNumber`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * @description Enter existing Tags to get table data
         *
         * @tags InstalledSensors
         * @name InstalledSensorsTagsList
         * @summary Retrieves sensors information of the sensor with the specified tags.
         * @request GET:/Api/InstalledSensors/Tags
         * @secure
         */
        installedSensorsTagsList: (
            query?: {
                tags?: string[]
            },
            params: RequestParams = {}
        ) =>
            this.request<InstalledSensorsDataDto[], any>({
                path: `/Api/InstalledSensors/Tags`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * @description Fetched on demand rather than with the sensor list, since generating a read SAS per image is costly.
         *
         * @tags InstalledSensors
         * @name InstalledSensorsImagesList
         * @summary Retrieves the uploaded images for a single sensor.
         * @request GET:/Api/InstalledSensors/Images
         * @secure
         */
        installedSensorsImagesList: (
            query: {
                /** SensorDbKey for sensor */
                sensorDbKey: string
            },
            params: RequestParams = {}
        ) =>
            this.request<ExistingImageDto[], any>({
                path: `/Api/InstalledSensors/Images`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags InstalledSensors
         * @name InstalledSensorsTimeseriesList
         * @summary Retrieves timeseries values for battery and signal strength
         * @request GET:/Api/InstalledSensors/Timeseries
         * @secure
         */
        installedSensorsTimeseriesList: (
            query: {
                sensorDbKey: string
            },
            params: RequestParams = {}
        ) =>
            this.request<TimeseriesDto, any>({
                path: `/Api/InstalledSensors/Timeseries`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags InstalledSensors
         * @name InstalledSensorsTimeseriesLatestList
         * @summary Retrieves latest timeseries values
         * @request GET:/Api/InstalledSensors/timeseries/latest
         * @secure
         */
        installedSensorsTimeseriesLatestList: (
            query: {
                /** The time series table key */
                timeSeriesTableDbKey: string
            },
            params: RequestParams = {}
        ) =>
            this.request<TimeseriesLatestDto, any>({
                path: `/Api/InstalledSensors/timeseries/latest`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * @description Enter existing SensorDbKeys to get table data
         *
         * @tags InstalledSensors
         * @name InstalledSensorsSensorDbKeysList
         * @summary Retrieves sensor information of the sensors with the specified sensorDbKeys.
         * @request GET:/Api/InstalledSensors/SensorDbKeys
         * @secure
         */
        installedSensorsSensorDbKeysList: (
            query?: {
                sensorDbKeys?: (string | null)[]
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/Api/InstalledSensors/SensorDbKeys`,
                method: 'GET',
                query: query,
                secure: true,
                ...params,
            }),

        /**
         * No description
         *
         * @tags InstalledSensors
         * @name InstalledSensorsSensorConfigurationsDetail
         * @summary Retrieves sensor metadata configurations for the given sensorDbKey.
         * @request GET:/Api/InstalledSensors/sensor/{sensorDbKey}/configurations
         * @secure
         */
        installedSensorsSensorConfigurationsDetail: (sensorDbKey: string, params: RequestParams = {}) =>
            this.request<SensorMetadataConfigurationResponseDto, any>({
                path: `/Api/InstalledSensors/sensor/${sensorDbKey}/configurations`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * @description The SensorDbKey and OmniaIDs fields should not be included in the request body. The table will generate new SensorDbKey values, and OmniaIDs should be handled separately.
         *
         * @tags InstalledSensors
         * @name InstalledSensorsOnboardOneOrInBulkCreate
         * @summary Add sensor (one or in bulk) to installedSensors Db
         * @request POST:/Api/InstalledSensors/Onboard one or in bulk
         * @secure
         */
        installedSensorsOnboardOneOrInBulkCreate: (data: InstalledSensorsData[], params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/Api/InstalledSensors/Onboard one or in bulk`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * @description Input a sensorDbKey to delete sensor.
         *
         * @tags InstalledSensors
         * @name InstalledSensorsPlantSensorDeleteDelete
         * @summary Updates sensor status in Db and STID for onboarded sensors. Deletes sensor from Db for failed/drafted sensors.
         * @request DELETE:/Api/InstalledSensors/plant/{plant}/sensor/delete
         * @secure
         */
        installedSensorsPlantSensorDeleteDelete: (
            plant: string,
            data: string,
            query?: {
                /** Username. */
                userName?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/Api/InstalledSensors/plant/${plant}/sensor/delete`,
                method: 'DELETE',
                query: query,
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags LoRaWanDb
         * @name LoRaWanDbAllList
         * @summary Retrieves information about all installed sensors.
         * @request GET:/Api/LoRaWanDb/All
         * @secure
         */
        loRaWanDbAllList: (params: RequestParams = {}) =>
            this.request<InstalledSensorsData[], any>({
                path: `/Api/LoRaWanDb/All`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * @description Enter existing devEUIs to get table data
         *
         * @tags LoRaWanDb
         * @name LoRaWanDbDevEuiList
         * @summary Retrieves LoRaWan information of the sensor with the devEUIs.
         * @request GET:/Api/LoRaWanDb/devEUI
         * @secure
         */
        loRaWanDbDevEuiList: (
            query?: {
                devEuis?: string[]
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/Api/LoRaWanDb/devEUI`,
                method: 'GET',
                query: query,
                secure: true,
                ...params,
            }),

        /**
         * @description Enter existing serialNumber to get table data
         *
         * @tags LoRaWanDb
         * @name LoRaWanDbSerialNumberList
         * @summary Retrieves LoRaWan information of the sensor with the serialNumber.
         * @request GET:/Api/LoRaWanDb/serialNumber
         * @secure
         */
        loRaWanDbSerialNumberList: (
            query?: {
                serialNumber?: string[]
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/Api/LoRaWanDb/serialNumber`,
                method: 'GET',
                query: query,
                secure: true,
                ...params,
            }),

        /**
         * @description DevEUI, AppEUI, EncryptedAppKey and InitializationVector are required fields for each sensor.
         *
         * @tags LoRaWanDb
         * @name LoRaWanDbOnboardCreate
         * @summary Add sensor (one or in bulk) to LoRaWan Db
         * @request POST:/Api/LoRaWanDb/Onboard
         * @secure
         */
        loRaWanDbOnboardCreate: (data: DbLoRaWanData[], params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/Api/LoRaWanDb/Onboard`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * @description Delete one or more lines of content from table, based on DevEUI.
         *
         * @tags LoRaWanDb
         * @name LoRaWanDbDeleteDelete
         * @summary Deletes one or more LoRaWan key information.
         * @request DELETE:/Api/LoRaWanDb/Delete
         * @secure
         */
        loRaWanDbDeleteDelete: (data: string[], params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/Api/LoRaWanDb/Delete`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Measurements
         * @name MeasurementsPlantTagDetail
         * @summary Getting measurements
         * @request GET:/Api/Measurements/plant/{plant}/tag/{tag}
         * @secure
         */
        measurementsPlantTagDetail: (plant: string, tag: string, params: RequestParams = {}) =>
            this.request<OmniaTimeSeriesDto[], any>({
                path: `/Api/Measurements/plant/${plant}/tag/${tag}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Migrate
         * @name MigrateCreate
         * @summary Runs any pending one-off data migrations. Versions already recorded in the Migration table are skipped.
         * @request POST:/Api/Migrate
         * @secure
         */
        migrateCreate: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/Api/Migrate`,
                method: 'POST',
                secure: true,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Ping
         * @name PingStidList
         * @summary Checks connection to STID.
         * @request GET:/api/Ping/Stid
         * @secure
         */
        pingStidList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Ping/Stid`,
                method: 'GET',
                secure: true,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Ping
         * @name PingOmniaTimeseriesList
         * @summary Checks connection to OmniaTimeSeries.
         * @request GET:/api/Ping/OmniaTimeseries
         * @secure
         */
        pingOmniaTimeseriesList: (params: RequestParams = {}) =>
            this.request<Record<string, boolean>, any>({
                path: `/api/Ping/OmniaTimeseries`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * @description Ping connection to DB to check connection is healthy.
         *
         * @tags Ping
         * @name PingCheckDbHealthList
         * @summary Checks connection to database.
         * @request GET:/api/Ping/CheckDbHealth
         * @secure
         */
        pingCheckDbHealthList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Ping/CheckDbHealth`,
                method: 'GET',
                secure: true,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Ping
         * @name PingCheckSensorsList
         * @summary Check status for sensors
         * @request GET:/api/Ping/CheckSensors
         * @secure
         */
        pingCheckSensorsList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Ping/CheckSensors`,
                method: 'GET',
                secure: true,
                ...params,
            }),

        /**
         * No description
         *
         * @tags SensorMetadata
         * @name SensorMetadataAllList
         * @summary Retrieves meta data for all the different types of timeseries.
         * @request GET:/Api/SensorMetadata/All
         * @secure
         */
        sensorMetadataAllList: (params: RequestParams = {}) =>
            this.request<SensorMetaData[], any>({
                path: `/Api/SensorMetadata/All`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags SensorMetadata
         * @name SensorMetadataProtocolsList
         * @summary Retrieves a list of all distinct protocols from the device catalogue.
         * @request GET:/Api/SensorMetadata/Protocols
         * @secure
         */
        sensorMetadataProtocolsList: (params: RequestParams = {}) =>
            this.request<string[], any>({
                path: `/Api/SensorMetadata/Protocols`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags SensorMetadata
         * @name SensorMetadataVendorList
         * @summary Retrieves meta data for all the different types of timeseries from the specified sensor vendor.
         * @request GET:/Api/SensorMetadata/Vendor
         * @secure
         */
        sensorMetadataVendorList: (
            query?: {
                vendor?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<SensorMetaData[], any>({
                path: `/Api/SensorMetadata/Vendor`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags SensorMetadata
         * @name SensorMetadataSensorModelList
         * @summary Retrieves meta data for all the different types of timeseries from the specified sensor model.
         * @request GET:/Api/SensorMetadata/SensorModel
         * @secure
         */
        sensorMetadataSensorModelList: (
            query?: {
                sensorModel?: string[]
            },
            params: RequestParams = {}
        ) =>
            this.request<SensorMetaData[], any>({
                path: `/Api/SensorMetadata/SensorModel`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags SensorMetadata
         * @name SensorMetadataOnboardOneOrInBulkCreate
         * @summary Add sensor meta data (one or in bulk).
         * @request POST:/Api/SensorMetadata/Onboard one or in bulk
         * @secure
         */
        sensorMetadataOnboardOneOrInBulkCreate: (data: SensorMetaData[], params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/Api/SensorMetadata/Onboard one or in bulk`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * @description This request will remove all content of the table of the selected SensorModel. Use this cautiously!
         *
         * @tags SensorMetadata
         * @name SensorMetadataRemoveBySensorModelDelete
         * @summary Delete sensor meta data by specifying sensor model. NB: DO NOT USE UNLESS THERE IS A DISCONTINUED SENSORMODEL
         * @request DELETE:/Api/SensorMetadata/Remove by SensorModel
         * @secure
         */
        sensorMetadataRemoveBySensorModelDelete: (
            query?: {
                sensorModel?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/Api/SensorMetadata/Remove by SensorModel`,
                method: 'DELETE',
                query: query,
                secure: true,
                ...params,
            }),

        /**
         * @description Delete one or more lines of content from table, based on SensorMetadataDbKey.
         *
         * @tags SensorMetadata
         * @name SensorMetadataDeleteOneOrBulkOfSensormetadataWithSensorMetadataDbKeysDelete
         * @summary Deletes one or more lines of content from table, based on SensorMetadataDbKey
         * @request DELETE:/Api/SensorMetadata/Delete one or bulk of sensormetadata with SensorMetadataDbKeys
         * @secure
         */
        sensorMetadataDeleteOneOrBulkOfSensormetadataWithSensorMetadataDbKeysDelete: (
            data: SensorMetadataDeleteDto,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/Api/SensorMetadata/Delete one or bulk of sensormetadata with SensorMetadataDbKeys`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),

        /**
 * No description
 *
 * @tags Sync
 * @name SyncTimeseriesCreate
 * @summary Synchronizes the TimeseriesTable (and Omnia) for an existing sensor against the current SensorMetadata for its SensorModel and DeviceProfile.
Missing timeseries are created. Existing but deviating timeseries are updated when UpdateExistingTimeseries is true.
 * @request POST:/Api/Sync/timeseries
 * @secure
 */
        syncTimeseriesCreate: (data: SyncTimeseriesRequest, params: RequestParams = {}) =>
            this.request<SyncTimeseriesResponseDto, ProblemDetails>({
                path: `/Api/Sync/timeseries`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UserSettings
         * @name GetUserSettings
         * @summary Get users settings
         * @request GET:/Api/UserSettings
         * @secure
         */
        getUserSettings: (params: RequestParams = {}) =>
            this.request<UserSettingsDto, any>({
                path: `/Api/UserSettings`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags UserSettings
         * @name UpsertUserSettings
         * @summary Update users settings
         * @request POST:/Api/UserSettings
         * @secure
         */
        upsertUserSettings: (data: UserSettingsDto, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/Api/UserSettings`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),
    }
    all = {
        /**
         * No description
         *
         * @tags Devices
         * @name GetAll
         * @summary Get devices
         * @request GET:/all
         * @secure
         */
        getAll: (params: RequestParams = {}) =>
            this.request<DeviceDto[], any>({
                path: `/all`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
    }
    echo = {
        /**
         * No description
         *
         * @tags Echo
         * @name ViewsCreate
         * @summary Creates an Echo view from the supplied sensors and returns the URL to open in Echo.
         * @request POST:/Echo/Views
         * @secure
         */
        viewsCreate: (data: CreateEchoViewRequest, params: RequestParams = {}) =>
            this.request<EchoViewResult, any>({
                path: `/Echo/Views`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    }
    integrationTests = {
        /**
         * No description
         *
         * @tags IntegrationTests
         * @name OnboardOffboardInvenioRh1BList
         * @summary Onboards and offboards two sensors of model Invenio RH-1B, includes checks for successful onboarding and offboarding
         * @request GET:/IntegrationTests/Onboard-Offboard Invenio RH-1B
         * @secure
         */
        onboardOffboardInvenioRh1BList: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/IntegrationTests/Onboard-Offboard Invenio RH-1B`,
                method: 'GET',
                secure: true,
                ...params,
            }),

        /**
         * No description
         *
         * @tags IntegrationTests
         * @name OnboardOffboardAloxyPulseV01List
         * @summary Onboards and offboards two sensors of model Pulse v01, includes checks for successful onboarding and offboarding
         * @request GET:/IntegrationTests/Onboard-Offboard Aloxy Pulse v01
         * @secure
         */
        onboardOffboardAloxyPulseV01List: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/IntegrationTests/Onboard-Offboard Aloxy Pulse v01`,
                method: 'GET',
                secure: true,
                ...params,
            }),
    }
    omniaTimeseries = {
        /**
         * No description
         *
         * @tags OmniaTimeseries
         * @name GetMetadata
         * @summary Retrieves metadata from OmniaID
         * @request GET:/OmniaTimeseries/Metadata/{omniaId}
         * @secure
         */
        getMetadata: (omniaId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/OmniaTimeseries/Metadata/${omniaId}`,
                method: 'GET',
                secure: true,
                ...params,
            }),

        /**
         * No description
         *
         * @tags OmniaTimeseries
         * @name CreateTimeseries
         * @summary Creates an Omnia timeseries.
         * @request POST:/OmniaTimeseries
         * @secure
         */
        createTimeseries: (data: TimeseriesRequestItem[], params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/OmniaTimeseries`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags OmniaTimeseries
         * @name DeleteTimeseries
         * @summary Deletes timeseries belonging to the specified OmniaId (single).
         * @request DELETE:/OmniaTimeseries/SingleId
         * @secure
         */
        deleteTimeseries: (
            query: {
                omniaId: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/OmniaTimeseries/SingleId`,
                method: 'DELETE',
                query: query,
                secure: true,
                ...params,
            }),

        /**
         * No description
         *
         * @tags OmniaTimeseries
         * @name BulkDeleteTimeseries
         * @summary Deletes timeseries belonging to the specified OmniaId (in bulk).
         * @request DELETE:/OmniaTimeseries/BulkIds
         * @secure
         */
        bulkDeleteTimeseries: (data: string[], params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/OmniaTimeseries/BulkIds`,
                method: 'DELETE',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags OmniaTimeseries
         * @name TimeseriesDetail
         * @summary Get time series values
         * @request GET:/OmniaTimeseries/timeseries/{timeSeriesTableId}
         * @secure
         */
        timeseriesDetail: (
            timeSeriesTableId: string,
            query?: {
                /**
                 * Optional start date for time series values
                 * @format date-time
                 */
                from?: string
                /**
                 * Optional end date for time series values
                 * @format date-time
                 */
                to?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<TrendDto[], any>({
                path: `/OmniaTimeseries/timeseries/${timeSeriesTableId}`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),
    }
    onboarding = {
        /**
         * No description
         *
         * @tags Onboarding
         * @name SensorPlantCreate
         * @summary Onboard sensors to Omnia, STID, installedSensor db and timeseries db
         * @request POST:/Onboarding/sensor/plant/{plant}
         * @secure
         */
        sensorPlantCreate: (
            plant: string,
            data: OnboardingRequest,
            query?: {
                /**
                 * Commit status change in STID, setting it to as built, note that this means it can no longer be deleted.
                 * @default false
                 */
                commitStatusChange?: boolean
                /**
                 * Post to STID
                 * @default true
                 */
                postToStid?: boolean
                /**
                 * Post to Omnia
                 * @default true
                 */
                postToOmnia?: boolean
                /**
                 * Setup dataflow
                 * @default true
                 */
                setupDataflow?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/Onboarding/sensor/plant/${plant}`,
                method: 'POST',
                query: query,
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Onboarding
         * @name SensorPlantAsyncCreate
         * @summary Onboard sensors to Omnia, STID, installedSensor db and timeseries db async
         * @request POST:/Onboarding/sensor/plant/{plant}/async
         * @secure
         */
        sensorPlantAsyncCreate: (
            plant: string,
            data: {
                Plant: string
                Project: string
                SensorModel: string
                PlantId?: string
                /** @format uuid */
                'Sensor.SensorDbKey'?: string
                'Sensor.SuperiorTag'?: string
                'Sensor.Area'?: string
                'Sensor.Coordinates'?: string
                'Sensor.Tag'?: string
                'Sensor.VendorSerialNumber'?: string
                'Sensor.DevEui'?: string
                'Sensor.UserAddedDescription'?: string
                'Sensor.CompleteDescription'?: string
                'Sensor.CoordinatesNotAvailable'?: boolean
                'Sensor.Images'?: InsertImageFormDto[]
                'Sensor.ExistingImageUrls'?: ExistingImageDto[]
            },
            query?: {
                /**
                 * Commit status change in STID, setting it to as built, note that this means it can no longer be deleted.
                 * @default false
                 */
                commitStatusChange?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<OnboardSensorsResponseDto, ProblemDetails>({
                path: `/Onboarding/sensor/plant/${plant}/async`,
                method: 'POST',
                query: query,
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
 * No description
 *
 * @tags Onboarding
 * @name SensorPlantAsyncBulkCreate
 * @summary Onboard sensors in bulk from a JSON array of onboarding requests.
Each item is processed independently; partial failures are captured in the response
rather than aborting the entire batch.
 * @request POST:/Onboarding/sensor/plant/{plant}/async/bulk
 * @secure
 */
        sensorPlantAsyncBulkCreate: (
            plant: string,
            data: OnboardingRequestDto[],
            query?: {
                /**
                 * Commit status change in STID (sets sensor to as-built; irreversible).
                 * @default false
                 */
                commitStatusChange?: boolean
                /** @default true */
                postToStid?: boolean
                /** @default true */
                postToOmnia?: boolean
                /** @default true */
                setupDataflow?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<BulkOnboardSensorsResponseDto, ProblemDetails>({
                path: `/Onboarding/sensor/plant/${plant}/async/bulk`,
                method: 'POST',
                query: query,
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Onboarding
         * @name SensorPlantAsyncBulkSpreadsheetCreate
         * @summary Onboard sensors in bulk from an uploaded .xlsx spreadsheet.
         * @request POST:/Onboarding/sensor/plant/{plant}/async/bulk/spreadsheet
         * @secure
         */
        sensorPlantAsyncBulkSpreadsheetCreate: (
            plant: string,
            data: {
                /**
                 * The .xlsx spreadsheet file containing sensor onboarding data.
                 * @format binary
                 */
                file?: File
            },
            query?: {
                /**
                 * Commit status change in STID (sets sensor to as-built; irreversible).
                 * @default false
                 */
                commitStatusChange?: boolean
                /**
                 * Post to STID.
                 * @default true
                 */
                postToStid?: boolean
                /**
                 * Post to Omnia.
                 * @default true
                 */
                postToOmnia?: boolean
                /**
                 * Setup dataflow.
                 * @default false
                 */
                setupDataflow?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<BulkOnboardSensorsResponseDto, ProblemDetails>({
                path: `/Onboarding/sensor/plant/${plant}/async/bulk/spreadsheet`,
                method: 'POST',
                query: query,
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Onboarding
         * @name SensorPlantDraftCreate
         * @summary Save onboarded sensors as draft.
         * @request POST:/Onboarding/sensor/plant/{plant}/draft
         * @secure
         */
        sensorPlantDraftCreate: (
            plant: string,
            data: {
                Plant: string
                Project: string
                SensorModel: string
                PlantId?: string
                /** @format uuid */
                'Sensor.SensorDbKey'?: string
                'Sensor.SuperiorTag'?: string
                'Sensor.Area'?: string
                'Sensor.Coordinates'?: string
                'Sensor.Tag'?: string
                'Sensor.VendorSerialNumber'?: string
                'Sensor.DevEui'?: string
                'Sensor.UserAddedDescription'?: string
                'Sensor.CompleteDescription'?: string
                'Sensor.CoordinatesNotAvailable'?: boolean
                'Sensor.Images'?: InsertImageFormDto[]
                'Sensor.ExistingImageUrls'?: ExistingImageDto[]
            },
            params: RequestParams = {}
        ) =>
            this.request<OnboardSensorsResponseDto, any>({
                path: `/Onboarding/sensor/plant/${plant}/draft`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Onboarding
         * @name SensorPlantEditUpdate
         * @summary Edit a given sensor
         * @request PUT:/Onboarding/sensor/{sensorId}/plant/{plant}/edit
         * @secure
         */
        sensorPlantEditUpdate: (
            sensorId: string,
            plant: string,
            data: UpdateSensorsDataDto,
            params: RequestParams = {}
        ) =>
            this.request<EditSensorResponseDto, any>({
                path: `/Onboarding/sensor/${sensorId}/plant/${plant}/edit`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * @description USE WITH CAUTION: Delete sensors from all systems by tags, the order is Omnia, STID, installedSensor db, timeseries db
         *
         * @tags Onboarding
         * @name DeleteSensorsDelete
         * @summary Deletes sensors from all systems by tags. NB: USE WITH CAUSION
         * @request DELETE:/Onboarding/DeleteSensors
         * @secure
         */
        deleteSensorsDelete: (
            data: string[],
            query?: {
                plantShortName?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/Onboarding/DeleteSensors`,
                method: 'DELETE',
                query: query,
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),
    }
    plants = {
        /**
         * No description
         *
         * @tags PlantOverview
         * @name GetPlants
         * @summary Retrieves onboarded plants.
         * @request GET:/plants
         * @secure
         */
        getPlants: (
            query?: {
                /** @default false */
                onboardedOnly?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<PlantDto[], any>({
                path: `/plants`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
 * No description
 *
 * @tags PlantOverview
 * @name GetPlantStatusAccess
 * @summary Returns whether the current user may view the Plant status page for the given
plant. Omit plant (or pass empty) to check the "all plants"
view, which requires admin access. The rule is enforced entirely on the backend.
 * @request GET:/plants/status-access
 * @secure
 */
        getPlantStatusAccess: (
            query?: {
                plant?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<boolean, any>({
                path: `/plants/status-access`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PlantOverview
         * @name ProjectsPlantDetail
         * @summary Get projects for given plant
         * @request GET:/plants/projects/plant/{plant}
         * @secure
         */
        projectsPlantDetail: (plant: string, params: RequestParams = {}) =>
            this.request<ProjectDto[], any>({
                path: `/plants/projects/plant/${plant}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PlantOverview
         * @name SystemsPlantDetail
         * @summary Get systems for given plant
         * @request GET:/plants/systems/plant/{plant}
         * @secure
         */
        systemsPlantDetail: (plant: string, params: RequestParams = {}) =>
            this.request<SystemDto[], any>({
                path: `/plants/systems/plant/${plant}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PlantOverview
         * @name AreasPlantDetail
         * @summary Get areas for given plant
         * @request GET:/plants/areas/plant/{plant}
         * @secure
         */
        areasPlantDetail: (plant: string, params: RequestParams = {}) =>
            this.request<AreaDto[], any>({
                path: `/plants/areas/plant/${plant}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags PlantOverview
         * @name SuperiortagsPlantDetail
         * @summary Get superior tags for given plant
         * @request GET:/plants/superiortags/plant/{plant}
         * @secure
         */
        superiortagsPlantDetail: (plant: string, params: RequestParams = {}) =>
            this.request<SuperiorTagDto[], any>({
                path: `/plants/superiortags/plant/${plant}`,
                method: 'GET',
                secure: true,
                format: 'json',
                ...params,
            }),
    }
    stid = {
        /**
         * No description
         *
         * @tags Stid
         * @name IIoTTagCreate
         * @summary Adds IIoT Tags to STID.
         * @request POST:/Stid/IIoTTag
         * @secure
         */
        iIoTTagCreate: (
            data: StidTagRequestModel[],
            query?: {
                /** Username. */
                userName?: string
                /**
                 * Commit changes or rollback for validation.
                 * @default false
                 */
                commit?: boolean
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/Stid/IIoTTag`,
                method: 'POST',
                query: query,
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Stid
         * @name GetTagData
         * @summary Retrieves details of IIoT tags.
         * @request POST:/Stid/plant/{plant}/tag-details
         * @secure
         */
        getTagData: (plant: string, data: string[], params: RequestParams = {}) =>
            this.request<TagDataDto[], any>({
                path: `/Stid/plant/${plant}/tag-details`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Stid
         * @name GetImage
         * @summary Retrieve uploaded image.
         * @request POST:/Stid/plant/{plant}/image/{id}
         * @secure
         */
        getImage: (plant: string, id: number, params: RequestParams = {}) =>
            this.request<FileHolderDto, any>({
                path: `/Stid/plant/${plant}/image/${id}`,
                method: 'POST',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Stid
         * @name DeleteImage
         * @summary Delete image.
         * @request DELETE:/Stid/plant/{plant}/image/{docNo}/delete
         * @secure
         */
        deleteImage: (plant: string, docNo: string, params: RequestParams = {}) =>
            this.request<boolean, any>({
                path: `/Stid/plant/${plant}/image/${docNo}/delete`,
                method: 'DELETE',
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Stid
         * @name UpdateImageDescription
         * @summary Update image.
         * @request PUT:/Stid/plant/{plant}/image/{docNo}/update
         * @secure
         */
        updateImageDescription: (plant: string, docNo: string, data: string, params: RequestParams = {}) =>
            this.request<boolean, any>({
                path: `/Stid/plant/${plant}/image/${docNo}/update`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Stid
         * @name InsertImage
         * @summary Insert image (multipart).
         * @request POST:/Stid/plant/{plant}/tag/{tag}/image/insert
         * @secure
         */
        insertImage: (
            plant: string,
            tag: string,
            data: {
                /** @format binary */
                File?: File
                Description?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<boolean, string>({
                path: `/Stid/plant/${plant}/tag/${tag}/image/insert`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Stid
         * @name PlantTagsDetail
         * @summary Retrieves tags.
         * @request GET:/Stid/plant/{plant}/tags
         * @secure
         */
        plantTagsDetail: (
            plant: string,
            query?: {
                /** Project. */
                project?: string
                /** Device */
                device?: string
                /** System */
                system?: string
                /** Area */
                area?: string
                /** Free text tag number filter, used for type-ahead search. */
                tagNo?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<StidTagsResponseModel[], any>({
                path: `/Stid/plant/${plant}/tags`,
                method: 'GET',
                query: query,
                secure: true,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Stid
         * @name SystemCodesCreate
         * @summary Retrieves system codes.
         * @request POST:/Stid/SystemCodes
         * @secure
         */
        systemCodesCreate: (
            data: string[],
            query?: {
                /** The plant short name. */
                plantShortName?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/Stid/SystemCodes`,
                method: 'POST',
                query: query,
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Stid
         * @name NextSequenceNumberList
         * @summary Gets the next available sequence numbers.
         * @request GET:/Stid/NextSequenceNumber
         * @secure
         */
        nextSequenceNumberList: (
            query?: {
                /** The plant short name. */
                plantShortName?: string
                /**
                 * Amount of sequence numbers needed.
                 * @format int32
                 */
                numberOfSequences?: number
                /** Optional: The starting number string. */
                startNumberString?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/Stid/NextSequenceNumber`,
                method: 'GET',
                query: query,
                secure: true,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Stid
         * @name TagsDelete
         * @summary Deletes tag(s). It really deletes them, and does not set them to historic or any reversible operation - so be careful.
         * @request DELETE:/Stid/Tags
         * @secure
         */
        tagsDelete: (
            data: string[],
            query?: {
                /** The plant short name. */
                plantShortName?: string
                /**
                 * Commit changes or rollback for validation.
                 * @default false
                 */
                commit?: boolean
                /** Username. */
                userName?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/Stid/Tags`,
                method: 'DELETE',
                query: query,
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * @description This method is used to change the status of tags. A gives ASBUILT, H gives HISTORIC, it is not possible to go back.
         *
         * @tags Stid
         * @name TagStatusUpdate
         * @summary Changes the status of a tag.
         * @request PUT:/Stid/TagStatus
         * @secure
         */
        tagStatusUpdate: (
            data: string[],
            query?: {
                /** The plant short name. */
                plantShortName?: string
                /** The new status of the tag(s). */
                status?: string
                /**
                 * Commit changes or rollback for validation.
                 * @default false
                 */
                commit?: boolean
                /** Username. */
                userName?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/Stid/TagStatus`,
                method: 'PUT',
                query: query,
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),
    }
}
